module.exports = __webpack_public_path__ + "img/daoying.b15a9a0c.png";